import {
  DEFAULT_MARKS,
  MINS,
  MINUTES_TO_SLIDER_FORMAT,
} from "../consts/timeSlider";

import moment from "moment-timezone";

const getDisplayValue = (value) => {
  let displayValue = (value || 0) % 2400;

  if (displayValue < 0) {
    displayValue += 2400;
  }

  return displayValue;
};

const padZero = (hrs) => {
  return hrs > 9 ? hrs : `0${hrs}`;
};

export const getValueLabelValue = (value) => {
  let displayValue = getDisplayValue(value);

  const time = displayValue;
  const hrs = parseInt(time / 100);
  const mins = hrs > 0 ? time % (hrs * 100) : time;
  if (isNaN(hrs) || MINS[mins] === undefined) {
    throw new Error("Error creating valueLabelValue");
  }
  return padZero(hrs) + ":" + MINS[mins];
};

const getLabelValue = (value) => {
  let displayValue = getDisplayValue(value);

  return displayValue % 100 === 0 ? `${displayValue / 100}:00` : "";
};

export const generateMark = (startTime, duration) => {
  const marks = Array.from(new Array(duration))
    .map((_, index) => {
      return getHourlyMarks(startTime + index);
    })
    .flat();

  const value = (startTime + duration) * 100;

  marks.push({
    value,
    label: getLabelValue(value),
  });
  return marks;
};

const getHourlyMarks = (time) => {
  return DEFAULT_MARKS.map((mark) => {
    let value = mark.value + time * 100;

    return {
      value,
      label: getLabelValue(value),
    };
  });
};

// returns date in the 0 -> 2400 format
export const timeSliderFormat = (dateTime) => {
  const date = moment(dateTime);
  let hours = parseInt(date.format("HH"));
  let minutes = parseInt(date.format("mm"));
  let result = hours * 100 + MINUTES_TO_SLIDER_FORMAT[minutes];

  if (result / 100 > 22) {
    result = result - 2400;
  }

  return result;
};

export const POSITION_PER_MARK = {
  6: 4.16667,
  8: 3.125,
  12: 2.08333,
};

export const getPositionForLeft = ({ min, duration, position }) => {
  const value = (position - min) / 25;
  if (value < 0) return;
  return value * POSITION_PER_MARK[duration];
};
